module.exports = __webpack_public_path__ + "img/0-47.43a927fa.jpg";